<template>

  <div class="home-wrap">
    <img class="top-img" src="../../../assets/imgs/banner2.jpeg">
    <div class="contact-us-wrap">
      <div class="left-wrap">

        <div class="head-txt">
          工程案例与业绩
        </div>
        <div @click="qiehuanTab(index)" :class="currTab == index ?'item-txt item-txt-select':'item-txt'"
             v-for="(txt, index) in menuList">
          {{ txt.title }}
        </div>
        <div style="height: 40px"></div>

      </div>

      <div class="right-wrap">

        <div style="width: 100%;height: 1px;background-color: #333333"></div>

        <div class="text-title">
          当前位置：
          <div class="a-a" @click="goHome">首页</div>
          > 工程案例与业绩
          <img class="c-us" src="../../../assets/imgs/serve-phone.png">
          <div class="c-line"></div>
        </div>

        <div class="yfpt-w">
          <img src="../../../assets/imgs/white-top.png">
          <div style="height: 40px"></div>
          <div class="title">
            {{ menuList[currTab].title }}
          </div>

          <div class="time">{{ menuList[currTab].subtitle }}</div>
        </div>
        <div style="height: 40px"></div>
        <div id="p1" class="content-w">

        </div>
        <div style="height: 40px"></div>

      </div>
    </div>
  </div>

</template>

<script>
import $ from "jquery";

export default {
  name: "anliYjFragment",
  data: () => {

    return {
      currTab: 0,
    }
  },
  watch: {
    currTab(val) {
      $("#p1").empty()
      $("#p1").append(this.menuList[this.currTab].detail);
    },
  },
  computed: {
    menuList() {
      return this.$store.state.gcal
    }
  },
  mounted() {
    if (this.$store.state.gcal.length > 0) {
      if (this.$route.params.item) {
        this.currTab = this.menuList.indexOf(this.$route.params.item)
      }
    }
    $("#p1").empty()
    $("#p1").append(this.menuList[this.currTab].detail);
  },
  methods: {
    goHome() {
      this.$router.replace('/home')
    },
    qiehuanTab(i) {
      this.currTab = i
    }
  }
}
</script>

<style lang="less" scoped>
.home-wrap {

  display: flex;
  width: 1400px;
  min-width: 100%;
  align-items: center;
  background-color: white;
  flex-direction: column;

  .top-img {
    width: 100%;
    min-width: 100%;
  }

}

.contact-us-wrap {
  width: min-content;
  min-height: 100%;
  padding-top: 10px;
  min-width: 100%;
  display: flex;
  background-color: white;
  justify-content: center;

  .left-wrap {
    width: 230px;
    display: flex;
    flex-direction: column;

    .head-txt {
      background-color: #063979;
      width: 100%;
      height: 60px;
      line-height: 60px;
      color: white;
      font-size: 18px;
      padding-left: 20px;
    }

    .item-txt {
      width: 100%;
      background-color: #DEDFE0;
      padding: 20px;
      font-size: 16px;
      color: #666666;
      margin-top: 2px;
    }

    .item-txt-select {
      color: #143772;
      border-bottom: 1px #143772 solid;
    }
  }

  .right-wrap {
    display: flex;
    flex-direction: column;
    width: 970px;
    margin-left: 10px;

    .text-title {
      color: #666666;
      font-size: 16px;
      display: flex;
      height: 34px;
      align-items: center;
      position: relative;

      .c-us {
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .a-a {
        margin-left: 5px;
        margin-right: 5px;
        font-size: 16px;
        color: #666666;
      }

      .a-a:hover {
        text-decoration: underline;
        color: #22B5A8;
      }

      .c-line {
        background-color: #333333;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 20px;
      }
    }

    .yfpt-w {
      width: 100%;
      background-image: linear-gradient(to right, #1565A8, #84B2EF);
      position: relative;
      display: flex;
      margin-top: 40px;
      flex-direction: column;

      img {
        top: 20px;
        left: 30px;
        position: absolute;
      }

      .title {
        margin-left: 45px;
        color: white;
        margin-right: 20px;
        font-size: 18px;
      }

      .time {
        margin-top: 5px;
        margin-bottom: 20px;
        font-size: 14px;
        margin-left: 45px;
        color: white;
      }
    }

    .content-w {
      width: 100%;
      margin-top: 20px;
      margin-bottom: 30px;
    }
  }
}
</style>
